import Cookies from '../Helpers/cookies'

const authProvider = {

    login: ({ username, password }) => {
        const identifier = username // strapi expects 'identifier' and not 'username'
        const request = new Request(`${process.env.REACT_APP_API_URL}/auth/local`, {
            method: 'POST',
            body: JSON.stringify({ identifier, password }),
            headers: new Headers({ 'Content-Type': 'application/json'})
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                Cookies.setCookie('token', response.jwt, 1);
            });
    },

    logout: () => {
        Cookies.deleteCookie('token');
        return Promise.resolve();
    },

    checkAuth: () => {
        return Cookies.getCookie('token') ? Promise.resolve() : Promise.reject();
    },

    checkError: ({ status }) => {
        if (status === 401 || status === 403) {
            // Cookies.deleteCookie('token');
            // Cookies.deleteCookie('role');
            return Promise.reject();
        }
        return Promise.resolve();
    },

    getPermissions: () => {
        const user_details = new Request(`${process.env.REACT_APP_API_URL}/users/me?populate=*`, {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${Cookies.getCookie('token')}`})
        });
        
        return fetch(user_details)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                return response.role;
            });
    },
    
    getIdentity: () => {
        const user_details = new Request(`${process.env.REACT_APP_API_URL}/users/me?populate=*`, {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${Cookies.getCookie('token')}`})
        });
        
        return fetch(user_details)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                return response;
            });
    },
    changePassword: ({ currentPassword, password, passwordConfirmation  }) => {
        const changePassword = new Request(`${process.env.REACT_APP_API_URL}/auth/change-password`, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${Cookies.getCookie('token')}`}),
            body: JSON.stringify({ currentPassword, password, passwordConfirmation })
        });

        return fetch(changePassword)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                return response;
            }
        );
    }
}

export default authProvider;